export default "__VITE_ASSET___k1BtilQ__"